// File: frontend/src/routes/ProtectedRoute.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from '../components/common/Spinner';

const ProtectedRoute = ({ adminOnly = false }) => {
    const { user, loading } = useAuth();

    // 1. Wait for auth check to complete
    if (loading) {
        return <div style={{height: '100vh', display:'flex', justifyContent:'center', alignItems:'center'}}><Spinner /></div>;
    }

    // 2. Check if User is Logged In
    if (!user) {
        return <Navigate to="/admin/login" replace />;
    }

    // 3. Role-Based Check
    // Agar route 'adminOnly' hai, lekin user 'admin' nahi hai (wo editor hai) -> Redirect to Editor page
    if (adminOnly && user.role !== 'admin') {
        return <Navigate to="/admin/editor" replace />;
    }

    // 4. Access Granted
    return <Outlet />;
};

export default ProtectedRoute;